import { useEffect, useState } from 'react';
import AppContext from "../context";

import Router from "./Router";

import Data from '../repository';
import { trackMetaEvent } from '../utils/metaPixel';
import { clearExperienceCart } from '../utils/cart';

const App = () => {

	const [domain, setDomain ] = useState();
	const [user, setUser] = useState();
	const [domainNotFound, setDomainNotFound] = useState(false);

	const fetchDomain = async () => {
		try {
			const domain = await Data.fetchDomain();
			setDomain(domain.data);
			setDomainNotFound(false);
		} catch(error) {
			if (error.response?.status === 404) {
				setDomainNotFound(true);
			}
			throw error;
		}
	}

	const fetchUser = async () => {
		const user = await Data.fetchUser();
		setUser(user.data);
		try {
			await Data.resolveLocationId();
		} catch (error) {
			console.log(error);
		}
	}

	const handle401 = () => {
		// Clear the stale token directly rather than redirecting to /log-out - that route
		// only exists inside the "default" business-type router, so on domains that short-
		// circuit to a different router (e.g. businessType 'super-admin') before ever
		// reaching it, the token would never actually get cleared here, and this handler
		// would keep re-firing on every bootstrap, reloading the page forever.
		if(!localStorage.getItem('token')) return;
		localStorage.removeItem('token');
		clearExperienceCart();
		window.location.href = '/';
	}

	useEffect(() => {
		if(!domain?.metaPixelEnabled || !domain?.metaPixelId) return;
		trackMetaEvent({
			pixelId: domain.metaPixelId,
			eventName: 'PageView'
		});
	}, [domain?.metaPixelEnabled, domain?.metaPixelId]);

	return (
		<AppContext.Provider value={{
			domain,
			user,
			domainNotFound,
			fetchDomain,
			fetchUser,
			handle401,
		}}>
			<div style={{ '--primary-color': domain?.primaryColor, '--nav-bar-color': domain?.navBarColor, '--nav-bar-active-color': domain?.navBarActiveColor }}>
				<Router />
			</div>
		</AppContext.Provider>
	)
}

export default App;
